import { useQuery } from "@tanstack/react-query";
import {
  companyCommissionApi,
  type CompanyCommissionStatus,
} from "@/lib/company-commission.api";
import { queryKeys } from "@/lib/query-keys";

export type CompanyCommissionStatusFilter = CompanyCommissionStatus | "all";

export function useCompanyCommissions(status: CompanyCommissionStatusFilter, supplierId?: number) {
  return useQuery({
    queryKey: [
      ...queryKeys.companyCommissions(status),
      supplierId ?? "any",
    ] as const,
    queryFn: () =>
      companyCommissionApi
        .list({ status: status === "all" ? undefined : status, supplierId })
        .then((r) => r.data),
  });
}

export function useCompanyCommissionBatches() {
  return useQuery({
    queryKey: queryKeys.companyCommissionBatches(),
    queryFn: () => companyCommissionApi.listBatches().then((r) => r.data),
  });
}

export function useCompanyCommissionStats() {
  return useQuery({
    queryKey: queryKeys.companyCommissionStats(),
    queryFn: () => companyCommissionApi.stats().then((r) => r.data),
  });
}

export function useCompanyCommissionSupplierTotals() {
  return useQuery({
    queryKey: [...queryKeys.companyCommissionStats(), "supplier-totals"] as const,
    queryFn: () => companyCommissionApi.supplierTotals().then((r) => r.data),
  });
}
